/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdResponse,
} from '../models';

export interface DeleteAccountApplicationApiControllerApproveDeleteApplicationRequest {
    applicationId: string;
}

export interface DeleteAccountApplicationApiControllerCleanTestAccountRequest {
    userId: string;
}

export interface DeleteAccountApplicationApiControllerCreateDeleteApplicationV2Request {
    userId: string;
}

export interface DeleteAccountApplicationApiControllerRejectDeleteApplicationRequest {
    applicationId: string;
}

/**
 * 
 */
export class DeleteAccountApplicationApi extends runtime.BaseAPI {

    /**
     */
    async deleteAccountApplicationApiControllerApproveDeleteApplicationRaw(requestParameters: DeleteAccountApplicationApiControllerApproveDeleteApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling deleteAccountApplicationApiControllerApproveDeleteApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/delete-account-applications/{applicationId}:approve`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccountApplicationApiControllerApproveDeleteApplication(requestParameters: DeleteAccountApplicationApiControllerApproveDeleteApplicationRequest): Promise<void> {
        await this.deleteAccountApplicationApiControllerApproveDeleteApplicationRaw(requestParameters);
    }

    /**
     */
    async deleteAccountApplicationApiControllerCleanTestAccountRaw(requestParameters: DeleteAccountApplicationApiControllerCleanTestAccountRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling deleteAccountApplicationApiControllerCleanTestAccount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/test-accounts/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccountApplicationApiControllerCleanTestAccount(requestParameters: DeleteAccountApplicationApiControllerCleanTestAccountRequest): Promise<void> {
        await this.deleteAccountApplicationApiControllerCleanTestAccountRaw(requestParameters);
    }

    /**
     */
    async deleteAccountApplicationApiControllerCreateDeleteApplicationRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/delete-account-applications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccountApplicationApiControllerCreateDeleteApplication(): Promise<void> {
        await this.deleteAccountApplicationApiControllerCreateDeleteApplicationRaw();
    }

    /**
     */
    async deleteAccountApplicationApiControllerCreateDeleteApplicationV2Raw(requestParameters: DeleteAccountApplicationApiControllerCreateDeleteApplicationV2Request): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling deleteAccountApplicationApiControllerCreateDeleteApplicationV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/users/{userId}/delete-account-applications`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteAccountApplicationApiControllerCreateDeleteApplicationV2(requestParameters: DeleteAccountApplicationApiControllerCreateDeleteApplicationV2Request): Promise<IdResponse> {
        const response = await this.deleteAccountApplicationApiControllerCreateDeleteApplicationV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async deleteAccountApplicationApiControllerRejectDeleteApplicationRaw(requestParameters: DeleteAccountApplicationApiControllerRejectDeleteApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling deleteAccountApplicationApiControllerRejectDeleteApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/delete-account-applications/{applicationId}:reject`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccountApplicationApiControllerRejectDeleteApplication(requestParameters: DeleteAccountApplicationApiControllerRejectDeleteApplicationRequest): Promise<void> {
        await this.deleteAccountApplicationApiControllerRejectDeleteApplicationRaw(requestParameters);
    }

}
